import(/* webpackMode: "eager", webpackExports: ["BlogListingClient"] */ "/opt/hotlistcasino/frontend/src/components/blog/BlogListingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedLink"] */ "/opt/hotlistcasino/frontend/src/components/LocalizedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
